import React from "react";
import {numberWithCommas} from "../../../utils";


export default function AlignRightText({ text, style, numberComma, isParseInt=false }) {
  return (
    <div style={{ textAlign: 'right', ...style }}>
      {text && isParseInt ?
        (numberComma ? numberWithCommas(parseInt(text)) : parseInt(text)) : (numberComma ? numberWithCommas(text) : text)}
    </div>
  );
}
